export var EDrivingMarketSectionType;
(function (EDrivingMarketSectionType) {
    EDrivingMarketSectionType["GAIN"] = "gain";
    EDrivingMarketSectionType["LOSS"] = "loss";
    EDrivingMarketSectionType["HIGH"] = "high";
    EDrivingMarketSectionType["LOW"] = "low";
    EDrivingMarketSectionType["OUT"] = "out";
    EDrivingMarketSectionType["UNDER"] = "under";
    EDrivingMarketSectionType["PRICE"] = "price";
    EDrivingMarketSectionType["UPPER"] = "upper";
    EDrivingMarketSectionType["LOWER"] = "lower";
    EDrivingMarketSectionType["WEEK_HIGH"] = "weekHigh";
    EDrivingMarketSectionType["WEEK_LOW"] = "weekLow";
    EDrivingMarketSectionType["VOLUME"] = "volume";
    EDrivingMarketSectionType["PULLERS"] = "pullers";
    EDrivingMarketSectionType["DRAGGERS"] = "draggers";
})(EDrivingMarketSectionType || (EDrivingMarketSectionType = {}));
export var DrivingMarketMsgIcon;
(function (DrivingMarketMsgIcon) {
    DrivingMarketMsgIcon["LIMIT"] = "edel-icon-likes1";
    DrivingMarketMsgIcon["EMPTYSTOCK"] = "edel-icon-emtpy_icon";
    DrivingMarketMsgIcon["DEFAULT"] = "";
})(DrivingMarketMsgIcon || (DrivingMarketMsgIcon = {}));
export const drivingMarketLimit = 5;
